module.exports = __webpack_public_path__ + "img/onePressMicAnimation.40d81e57.svg";